import { connect } from 'react-redux';
import TambahKelasKhusus from '../../../views/Akademi/DataKelas/TambahKelasKhusus.view';
import { getLevels } from '../../../states/thunks/options.thunk';

function mapStateToProps(state) {
  return {
    user: state.user,
    levels: state.options.levels,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    handleGetLevels: payload => dispatch(getLevels(payload)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(TambahKelasKhusus);
